<template>
  <CardSection>
    <template #title>
      <h2 class="fs-2">REPORTS PENDING REVIEW BY REPORT TYPE</h2>
    </template>
    <template #content>
      <dl class="py-3">
        <MnRow>
          <MnColumn cols="9">
            <div class="mb-0">
              <MnRow class="justify-content-center">
                <MnColumn v-for="col in columns" :key="col.field" :colSpan="{ sm: 2 }">
                  <StatisticItem :label="col.header" :value="getValue(col.field)" />
                </MnColumn>
              </MnRow>
            </div>
            <div class="text-center">
              <PvButton label="Review Annual Reports"
                        class="px-5"
                        @click="handleReviewAnnualReports" rounded />
            </div>  
          </MnColumn>
          <MnColumn cols="3" class="border-start d-flex flex-column align-items-center">
            <div class="stat-width">
              <StatisticItem label="HCE" :value="getValue('hcetCount')" />
            </div>
            <div class="text-center">
              <PvButton label="Review HCE Transactions"
                        class="px-5"
                        @click="handleReviewHcetReports" rounded />
            </div>
          </MnColumn>

        </MnRow>
      </dl>
    </template>
  </CardSection>
</template>

<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core


// Component
import StatisticItem from '@/components/dashboard/StatisticItem.vue';
import CardSection from '@/components/common/CardSection.vue';
import MnRow from '@/components/common/MnRow.vue';
import MnColumn from '@/components/common/MnColumn.vue';

// Composables
import { usePageHelper } from '@/composables/pageHelper';
import { storeToRefs } from 'pinia';

// Stores
import { useProgramDashboardStore } from '../stores/ProgramDashboardStore';
import { onMounted } from 'vue';

// Constants and Utils


// ===============================
// PROPS & EMITS
// ===============================


// ===============================
// COMPOSABLES & STORES
// ===============================
const store = useProgramDashboardStore();
const { reportCounts } = storeToRefs(store);
const pageHelper = usePageHelper();

// ===============================
// REACTIVE STATE
// ===============================


// ===============================
// CONSTANTS
// ===============================
const columns = [
  { field: 'hpfsrCount', header: 'HPFSR' },
  { field: 'foscCount', header: 'FOSC' },
  { field: 'difurCount', header: 'DIFUR' },
  { field: 'cerrrCount', header: 'CERRR' },
  { field: 'uroparCount', header: 'UROPAR' },
];

// ===============================
// COMPUTED PROPERTIES
// ===============================


// ===============================
// METHODS
// ===============================
const handleReviewAnnualReports = () => {
  pageHelper.navigateToRouteName('programannualreports');
};
const handleReviewHcetReports = () => {
  pageHelper.navigateToRouteName('programHces');
};

const getValue = (field) => {
  return reportCounts.value !== null && reportCounts.value[field] !== null && reportCounts.value[field] !== undefined ? reportCounts.value[field] : null;
};
// ===============================
// WATCHERS
// ===============================


// ===============================
// LIFECYCLE HOOKS
// ===============================
onMounted(async () => {
  await pageHelper.fetch(() => store.fetch());
});

// ===============================
// EXPOSE
// ===============================


</script>

<style scoped>
.stat-width {
  width: 10rem;
  max-width: 12rem;
}
</style>